import styled from 'styled-components';
import { QuestionHead, QuestionHeader } from '../styled/styles';
import React, { useEffect, useState } from 'react';
import Checkbox from './Checkbox';
import ErrorDisplay from './ErrorDisplay';

const StyledDiv = styled.div`
    padding: 0 15px;
    display: ${props => props.toDisplay ? 'block' : 'none'};
    margin-bottom: 1.5rem;
`;

const QuestionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: ${props => props.hasError ? '1.5rem' : '0'};
    border-radius: ${props => props.hasError ? '0.5rem' : '0'};
    border: ${props => props.hasError ? `2px solid ${props.theme.errorBorder}` : 'none'};
    background-color: ${props => props.hasError ? props.theme.errorBg : 'transparent'};
`;

const ModernQuestionHead = styled(QuestionHead)`
    font-size: 1.125rem;
    font-weight: 500;
    color: ${props => props.theme.textSecondary};
    margin-top: 0;
    margin-bottom: 0;
`;

const ModernQuestionHeader = styled(QuestionHeader)`
    font-size: 1.5rem;
    font-weight: 700;
    color: ${props => props.theme.textPrimary};
    margin-top: 0;
    margin-bottom: 0;
    
    @media (min-width: 768px) {
        font-size: 1.875rem;
    }
`;

const TextAreaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    min-height: 150px;
    padding: 1rem;
    border: 2px solid ${props => props.theme.inputBorder};
    border-radius: 0.5rem;
    background-color: ${props => props.theme.inputBg};
    color: ${props => props.theme.textPrimary};
    font-size: 1rem;
    line-height: 1.5;
    font-family: inherit;
    resize: vertical;
    transition: ${props => props.theme.transition};
    
    &:focus {
        outline: none;
        border-color: ${props => props.theme.accentPrimary};
    }
    
    &::placeholder {
        color: ${props => props.theme.textMuted};
    }
    
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const CharacterCounter = styled.div`
    text-align: right;
    font-size: 0.875rem;
    color: ${props => props.theme.textMuted};
`;

const Open = ({ showQuestion, currentPage, toDisplay, question, answeredQuestions, setAnsweredQuestions, currentPageAnswers, setCurrentPageAnswers, parseDynamicQuestionText, errors, setErrors  }) => { 
  const [selectedStates, setSelectedStates] = useState(new Array(question.Answers.length).fill(''))
  const [disabled, setDisabled] = useState(false)

  const handleInputType = (event, answerExpression, index) => {
               
    let newValue = `${answerExpression.split('=')[0]}=${event.target.value !== "" ? event.target.value : "-998"}`

    let answeredQuestionsCopy = [...answeredQuestions]

    let openArrayIndex = answeredQuestionsCopy[currentPage - 1]?.findIndex(answer => typeof answer === 'object') 

    if (openArrayIndex < 0) {
      answeredQuestionsCopy[currentPage - 1]?.push([...selectedStates])
      openArrayIndex = 0
    } 

    typeof answeredQuestionsCopy[currentPage - 1][openArrayIndex] === 'string' ? 
    answeredQuestionsCopy[currentPage - 1][openArrayIndex] = newValue :
    answeredQuestionsCopy[currentPage - 1][openArrayIndex][index] = newValue

    let selectedStatesCopy = [...selectedStates]
    selectedStatesCopy[index] = event.target.value
      
    setSelectedStates(selectedStatesCopy);
    
    setAnsweredQuestions(answeredQuestionsCopy)
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])
  };

  useEffect(() => {
    let answeredQuestionsCopy = [...answeredQuestions]
                  
    if (!answeredQuestions[currentPage - 1] || !answeredQuestions[currentPage - 1].length)  {
      answeredQuestionsCopy[currentPage - 1] = []
      answeredQuestionsCopy[currentPage - 1].push(question.Answers.map(answer => answer.AnswerType === "None" ? `${answer.Expression.split('=')[0]}=0` : `${answer.Expression.split('=')[0]}=-998`))
    } else if (!answeredQuestions[currentPage - 1]?.some(ans => typeof ans === 'object')) {
      answeredQuestionsCopy[currentPage - 1] = [answeredQuestionsCopy[currentPage - 1]]
    }

                  

    let currentPageOpenAnswers = answeredQuestionsCopy[currentPage - 1].filter(ans => typeof ans === 'object')[0].filter(ans => ans.split('=')[0].includes(`${question.QuestionNo}`))

               
    if (currentPageOpenAnswers.filter(ans => !ans.includes('-998')).length) {
      setSelectedStates(currentPageOpenAnswers.map(answer => answer.split('=')[1] === "-998" ? "" : answer.split('=')[1]))
    } else {
      setSelectedStates(new Array(question.Answers.length).fill(''))
    }

    setAnsweredQuestions(answeredQuestionsCopy)
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])

  }, [])

  useEffect(() => {
       
    if (toDisplay && answeredQuestions[currentPage - 1]?.length) {

      if (answeredQuestions[currentPage - 1]?.some(ans => typeof ans === 'object')) {
        let openArrayIndex = answeredQuestions[currentPage - 1]?.findIndex(answer => typeof answer === 'object') 
        
        setSelectedStates(answeredQuestions[currentPage - 1][openArrayIndex].map(answerSelection => answerSelection.split('=')[1] !== '-998' ? answerSelection.split('=')[1] : ''))
      } else {
        let answeredQuestionsCopy = [...answeredQuestions]
        let openExpressionStub = question.Answers[0].AnswerCode.split('_')[0] 

        let newAnsweredQuestions = [...answeredQuestionsCopy[currentPage - 1]?.filter(ansExpression => !ansExpression.includes(openExpressionStub)), answeredQuestionsCopy[currentPage - 1]?.filter(ansExpression => ansExpression.includes(openExpressionStub))]
        let openArrayIndex = newAnsweredQuestions.findIndex(answer => typeof answer === 'object')

        if (openArrayIndex >= 0) {
          answeredQuestionsCopy[currentPage - 1] = newAnsweredQuestions 

          setAnsweredQuestions(answeredQuestionsCopy)
          setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])
          setSelectedStates(answeredQuestionsCopy[currentPage - 1][openArrayIndex].map(answerSelection => answerSelection.split('=')[1]))
        }
      }
    }
    setTimeout(() => {
      window.shown = question.Answers.filter(answer => showQuestion(answer.showIf)).length
    },200)
  },[toDisplay])
    
  // Check if there are errors for this question
  const hasError = errors && errors.includes(question.QuestionCode);
  
  // Calculate character count for the main text area (usually the first or only text answer)
  const mainTextIndex = question.Answers.findIndex(answer => answer.AnswerType === "TA");
  const characterCount = mainTextIndex >= 0 && selectedStates[mainTextIndex] !== "-998" 
    ? selectedStates[mainTextIndex]?.length || 0 
    : 0;
  const maxLength = 2000;

  return (
    <StyledDiv toDisplay={toDisplay}>
        <QuestionContainer hasError={hasError}>
            {question.QuestionHead && (
                <ModernQuestionHead>
                    {parseDynamicQuestionText(question.QuestionHead)}
                </ModernQuestionHead>
            )}
            
            <ModernQuestionHeader errors={errors} question={question}>
                {parseDynamicQuestionText(question.QuestionName)}
            </ModernQuestionHeader>

            {selectedStates && question.Answers.filter(answer => showQuestion(answer.showIf)).map((answer, i) => {
              window.shown ? window.shown++ : window.shown = 1;
              if (answer.AnswerType === "None") {
                return (
                  <div key={i}>
                    <Checkbox 
                      setDisabled={setDisabled} 
                      currentPage={currentPage} 
                      answeredQuestions={answeredQuestions} 
                      setAnsweredQuestions={setAnsweredQuestions} 
                      isOpen={true} 
                      selectedStates={selectedStates} 
                      setSelectedStates={setSelectedStates} 
                      index={i} 
                      label={answer.AnswerLabel} 
                    />
                  </div>
                )
              } else {
                return (
                  <TextAreaWrapper 
                    key={i} 
                    style={{display: !answer.showIf || showQuestion(answer.showIf) ? 'flex' : 'none'}}
                  >
                    {answer.AnswerType !== "TA" && (
                      <p style={{ margin: 0, color: 'inherit' }}>
                        {parseDynamicQuestionText(answer.AnswerLabel)}
                      </p>
                    )}
                    <StyledTextArea 
                      disabled={disabled} 
                      value={selectedStates[i] !== "-998" ? selectedStates[i] : ""} 
                      onChange={(e) => handleInputType(e, answer.Expression, i)} 
                      placeholder={answer.AnswerType === "TA" ? answer.AnswerLabel : "Type your answer here..."} 
                      maxLength={maxLength}
                    />
                    {answer.AnswerType === "TA" && (
                      <CharacterCounter>
                        {selectedStates[i] !== "-998" ? selectedStates[i]?.length || 0 : 0} / {maxLength} characters
                      </CharacterCounter>
                    )}
                  </TextAreaWrapper>
                )
              }
            })}
            
            <ErrorDisplay errors={errors} questionCode={question.QuestionCode} />
        </QuestionContainer>
    </StyledDiv>
  )
};

export default Open;